import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ProductDetailPage.css';
import '../assets/css/general.css';

import mainBigbagsImage from '../assets/img/products/bigbag.jpg';
import mainSacksCombinedImage from '../assets/img/products/sack.jpg';
import mainSpecialProductsImage from '../assets/img/products/pefilm/pefilm0.jpg';

import mainBigbagsStandardImage from '../assets/img/products/bigbag/standart.jpg';
import mainBigbags12LoopImage from '../assets/img/products/bigbag/2lop.jpg';
import mainBigbagsCrossCornerImage from '../assets/img/products/bigbag/standart.jpg';
import mainBigbagsVentilatedImage from '../assets/img/products/bigbag/ventilli.jpg';
import mainBigbagsQBagImage from '../assets/img/products/bigbag/qbag.jpg';

import mainSackStandardImage from '../assets/img/products/Sacks/standard.jpg';
import mainSackKraftImage from '../assets/img/products/Sacks/kraftsack.jpg';
import mainSackLaminatedImage from '../assets/img/products/Sacks/laminated1.jpg';
import mainSackBoppImage from '../assets/img/products/Sacks/bopp.jpg';
import mainSackBlockBottomImage from '../assets/img/products/Sacks/block_bottom.png';

import mainPefilmImage from '../assets/img/products/pefilm/pefilm4.jpg';
import mainThermalPalletCoverImage from '../assets/img/products/cover2/thermal_blanket/thermal_blanket1.jpg';
import mainContainerSafetySheetImage from '../assets/img/products/cover2/Safety_Sheets/inflatable1.jpg';

import bb_2lop from '../assets/img/products/bigbag/2lop.jpg';
import bb_2lop1 from '../assets/img/products/bigbag/2lop1.jpg';
import bb_4lob1 from '../assets/img/products/bigbag/4lob1.jpg';
import bb_4lob2 from '../assets/img/products/bigbag/4lob2.jpg';
import bb_4lob3 from '../assets/img/products/bigbag/4lob3.jpg';
import bb_4lob4 from '../assets/img/products/bigbag/4lob4.jpg';
import bb_4lob5 from '../assets/img/products/bigbag/4lob5.jpg';
import bb_4lop from '../assets/img/products/bigbag/4lop.jpg';
import bb_bigbag1 from '../assets/img/products/bigbag/bigbag1.jpg';
import bb_bigbag2 from '../assets/img/products/bigbag/bigbag2.jpg';
import bb_bigbag3 from '../assets/img/products/bigbag/bigbag3.jpg';
import bb_qbag from '../assets/img/products/bigbag/qbag.jpg';
import bb_standart from '../assets/img/products/bigbag/standart.jpg';
import bb_ventilli from '../assets/img/products/bigbag/ventilli.jpg';
import bb_ventilli1 from '../assets/img/products/bigbag/ventilli1.jpg';
import bb_ventilli2 from '../assets/img/products/bigbag/ventilli2.jpg';

// Cross Corner Images
import bb_crosscorner from '../assets/img/products/bigbag/crosscorner.PNG';
import bb_crosscorner2 from '../assets/img/products/bigbag/crosscorner2.PNG';

import pe_pefilm0 from '../assets/img/products/pefilm/pefilm0.jpg';
import pe_pefilm1 from '../assets/img/products/pefilm/pefilm1.jpg';
import pe_pefilm2 from '../assets/img/products/pefilm/pefilm2.jpg';
import pe_pefilm3 from '../assets/img/products/pefilm/pefilm3.jpg';
import pe_pefilm4 from '../assets/img/products/pefilm/pefilm4.jpg';
import pe_pefilm5 from '../assets/img/products/pefilm/pefilm5.jpg';
import pe_pefilm6 from '../assets/img/products/pefilm/pefilm6.jpg';
import pe_w1400coex0 from '../assets/img/products/pefilm/w1400coex-0.jpeg';
import pe_w1400coex1 from '../assets/img/products/pefilm/w1400coex-1.jpeg';
import pe_w1400coex2 from '../assets/img/products/pefilm/w1400coex-2.jpeg';
import pe_w1400coex3 from '../assets/img/products/pefilm/w1400coex-3.jpeg';
import pe_w1400coex4 from '../assets/img/products/pefilm/w1400coex-4.jpeg';
import pe_w1400coex5 from '../assets/img/products/pefilm/w1400coex-5.jpeg';
import pe_w1400coex6 from '../assets/img/products/pefilm/w1400coex-6.jpeg';
import pe_w1400coex7 from '../assets/img/products/pefilm/w1400coex-7.jpeg';
import pe_w1400coex8 from '../assets/img/products/pefilm/w1400coex-8.jpeg';

import sack_block_bottom from '../assets/img/products/Sacks/block_bottom.png';
import sack_block_bottom_seal_back from '../assets/img/products/Sacks/block_bottom_seal_back.jpg';
import sack_bopp from '../assets/img/products/Sacks/bopp.jpg';
import sack_kraftsack_detail from '../assets/img/products/Sacks/kraftsack.jpg';
import sack_laminated1 from '../assets/img/products/Sacks/laminated1.jpg';
import sack_laminated2 from '../assets/img/products/Sacks/laminated2.jpg';
import sack_standard_detail from '../assets/img/products/Sacks/standard.jpg';

// Thermal Pallet Cover Images
import thermal_blanket1 from '../assets/img/products/cover2/thermal_blanket/thermal_blanket1.jpg';
import thermal_blanket2 from '../assets/img/products/cover2/thermal_blanket/thermal_blanket2.jpg';
import thermal_blanket3 from '../assets/img/products/cover2/thermal_blanket/thermal_blanket3.jpg';

// Container Safety Sheets Images
import css_inflatable1 from '../assets/img/products/cover2/Safety_Sheets/inflatable1.jpg';
import css_inflatable2 from '../assets/img/products/cover2/Safety_Sheets/inflatable2.jpg';
import css_inflatable3 from '../assets/img/products/cover2/Safety_Sheets/inflatable3.jpg';
import css_safetynet1 from '../assets/img/products/cover2/Safety_Sheets/safetynet1.jpg';
import css_safetynet2 from '../assets/img/products/cover2/Safety_Sheets/safetynet2.jpg';
import css_safetynet_accessory1 from '../assets/img/products/cover2/Safety_Sheets/safetynet-accessory1.jpg';
import css_safetynet_accessory2 from '../assets/img/products/cover2/Safety_Sheets/safetynet-accessory2.jpg';
import css_standart1 from '../assets/img/products/cover2/Safety_Sheets/standart1.jpg';
import css_standart2 from '../assets/img/products/cover2/Safety_Sheets/standart2.jpg';
import css_standart3 from '../assets/img/products/cover2/Safety_Sheets/standart3.jpg';

const productData = [
  {
    id: 'big-bags',
    name: 'Big Bags (FIBC)',
    description: 'We offer a comprehensive range of Flexible Intermediate Bulk Containers (FIBCs), commonly known as Big Bags. These are designed for transporting and storing a wide variety of dry flowable products. Explore our specialized Big Bag types below to find the perfect solution for your needs.',
    image: mainBigbagsImage,
    isParentCategory: true,
    subCategories: [
        'big-bags-standard',
        'big-bags-1-2-loops',
        'big-bags-cross-corner',
        'big-bags-ventilated',
        'big-bags-q-bag'
    ],
    features: ['Wide Range of Types', 'Customizable Solutions', 'High Strength and Durability', 'Cost-Effective Bulk Handling', 'Suitable for Various Industries'],
    gallery: [
        { name: 'Various Big Bags Collection', src: mainBigbagsImage, alt: 'Various Big Bags Collection' },
        { name: 'Standard Big Bag Example', src: bb_standart, alt: 'Standard Big Bag Example' },
        { name: 'Q-Bag Example', src: bb_qbag, alt: 'Q-Bag Example' },
        { name: 'Ventilated Big Bag Example', src: bb_ventilli, alt: 'Ventilated Big Bag Example' },
    ]
  },
  {
    id: 'big-bags-standard',
    name: 'Standard Big Bags',
    description: 'Our Standard Big Bags are versatile and widely used across industries for their reliability and strength. Available with various top and bottom constructions.',
    image: mainBigbagsStandardImage,
    features: ['Durable Polypropylene Construction', 'Customizable SWL and SF', 'Various Filling and Discharge Options', 'UV Resistant Options', 'Suitable for Powders, Granules'],
    gallery: [
      { name: 'Standard Big Bag', src: bb_standart, alt: 'Standard Big Bag' },
      { name: 'Big Bag In Use', src: bb_bigbag1, alt: 'Big Bag Model 1' },
      { name: 'Big Bag In Use', src: bb_bigbag2, alt: 'Big Bag Model 2' },
      { name: 'Big Bag In Use', src: bb_bigbag3, alt: 'Big Bag Model 3' },
    ]
  },
  {
    id: 'big-bags-1-2-loops',
    name: '1 & 2 Loop Big Bags',
    description: '1 and 2 Loop Big Bags are an economical solution for handling bulk materials, often used for fertilizers, seeds, and cement. They are easy to handle and fill.',
    image: mainBigbags12LoopImage,
    features: ['Cost-Effective Design', 'Easy Handling with Single or Double Loops', 'Ideal for Automated Filling Lines', 'Liners for moisture protection', 'For 500kg to 1500kg loads'],
    gallery: [
      { name: '2 Loop Big Bag', src: bb_2lop, alt: '2 Loop Big Bag' },
      { name: '2 Loop Big Bag Lifted by forklift', src: bb_2lop1, alt: '2 Loop Big Bag - Variant 1' },
    ]
  },
  {
    id: 'big-bags-cross-corner',
    name: 'Cross Corner Big Bags',
    description: 'ADL CC, is called cross corner loops. The loops are sewn into the reinforced area of the fabric body. The body fabric is tubular. There is no seam on the body. Cross corner big bags are more economical comparing to standard big bags. Since the body fabric is tubular, there is no side seams on the body. By considering these, lower fabric can be manufactured while calculating the strength.',
    image: mainBigbagsCrossCornerImage,
    features: [
      'Loops sewn into reinforced fabric body area',
      'Tubular body fabric with no side seams',
      'More economical than standard big bags',
      'Lower fabric requirements due to tubular construction',
      'Available in multiple safety working loads',
      'Compliant with EFIBCA testing standards'
    ],
    specifications: {
      safetyWorkingLoads: [
        { load: '1,000 Kg', safetyFactor: '5:1, 6:1' },
        { load: '1,500 Kg', safetyFactor: '5:1' },
        { load: '2,000 Kg', safetyFactor: '5:1' }
      ],
      testingStandards: [
        { standard: 'EFIBCA005 (SF 5:1)', usage: 'Single use' },
        { standard: 'EFIBCA004 (SF 6:1)', usage: 'Multi use' }
      ]
    },
    gallery: [
      { name: 'Cross Corner Big Bag', src: bb_crosscorner, alt: 'Cross Corner Big Bag' },
      { name: 'Cross Corner Construction Detail', src: bb_crosscorner2, alt: 'Cross Corner Big Bag Construction Detail' },
    ]
  },
  {
    id: 'big-bags-ventilated',
    name: 'Ventilated Big Bags',
    description: 'Ventilated Big Bags are specially designed for products that require airflow, such as potatoes, onions, and firewood. The fabric allows air to circulate, keeping contents fresh.',
    image: mainBigbagsVentilatedImage,
    features: ['Breathable Polypropylene Fabric', 'Maintains Freshness of Perishable Goods', 'Prevents Moisture Build-up', 'Strong and Durable Construction', 'Ideal for Agricultural Products'],
    gallery: [
      { name: 'Ventilated Big Bag', src: bb_ventilli, alt: 'Ventilated Big Bag for Breathable Products' },
      { name: 'Ventilated - Type 1', src: bb_ventilli1, alt: 'Ventilated Big Bag Type 1' },
      { name: 'Ventilated - Type 2', src: bb_ventilli2, alt: 'Ventilated Big Bag Type 2' },
    ]
  },
  {
    id: 'big-bags-q-bag',
    name: 'Q-Bags (Baffle Bags)',
    description: 'Q-Bags, or Baffle Bags, have internal baffles that help the bag maintain its square shape when filled. This provides better stability and efficient use of storage and shipping space.',
    image: mainBigbagsQBagImage,
    features: ['Internal Baffles for Shape Retention', 'Improved Stability and Stackability', 'Optimal Space Utilization', 'Reduces Spillage and Product Loss', 'Ideal for Fine Powders'],
    gallery: [
      { name: 'Q-Bag (Baffle Bag)', src: bb_qbag, alt: 'Q-Bag for Form Stability' },
      { name: 'Q-Bag Filled Example', src: bb_qbag, alt: 'Q-Bag demonstrating shape' },
    ]
  },
  {
    id: 'bags',
    name: 'PP & Kraft Bags',
    description: 'A versatile range of Polypropylene (PP) and Kraft paper bags suitable for packaging various goods, from agricultural products and food items to construction materials and chemicals. Explore our different sack types below.',
    image: mainSacksCombinedImage,
    isParentCategory: true,
    subCategories: [
        'bags-standard-pp',
        'bags-kraft-paper',
        'bags-laminated',
        'bags-bopp',
        'bags-block-bottom'
    ],
    features: [
        'Durable Polypropylene & Eco-Friendly Kraft Paper',
        'High Tear Strength Options',
        'Moisture Resistant and Breathable Types',
        'Customizable Printing for Branding',
        'Variety of Constructions Available'
    ],
    gallery: [
        { name: 'Assortment of PP & Kraft Bags', src: mainSacksCombinedImage, alt: 'Assortment of PP & Kraft Sacks' },
        { name: 'Standard PP Sack Example', src: sack_standard_detail, alt: 'Standard PP Sack Example' },
        { name: 'Kraft Paper Sack Example', src: sack_kraftsack_detail, alt: 'Kraft Paper Sack Example' },
        { name: 'BOPP Sack Example', src: sack_bopp, alt: 'BOPP Sack Example' },
    ]
  },
  {
    id: 'bags-standard-pp',
    name: 'Standard PP Bags',
    description: 'Standard Polypropylene woven bags are a cost-effective and durable solution for packaging a wide range of goods such as grains, sugar, and animal feed.',
    image: mainSackStandardImage,
    features: ['High Strength and Durability', 'Lightweight and Economical', 'UV Stabilized Options', 'Available in Various Sizes and Colors', 'Suitable for Grains, Feed, Chemicals'],
    gallery: [
        { name: 'Standard PP Sack', src: sack_standard_detail, alt: 'Standard PP Sack' },
    ]
  },
  {
    id: 'bags-kraft-paper',
    name: 'Kraft Paper Bags',
    description: 'Eco-friendly Kraft paper bags are ideal for products requiring breathability, such as flour, cement, and other powdered materials. Available in multiple plies.',
    image: mainSackKraftImage,
    features: ['Eco-Friendly and Biodegradable', 'Excellent Breathability', 'Good Printability for Branding', 'Multiple Ply Options for Strength', 'Ideal for Flour, Cement, Food Products'],
    gallery: [
        { name: 'Kraft Paper Sack', src: sack_kraftsack_detail, alt: 'Kraft Paper Sack' },
    ]
  },
  {
    id: 'bags-laminated',
    name: 'Laminated PP Bags',
    description: 'Laminated Polypropylene bags provide an added layer of protection against moisture and environmental factors, making them suitable for products like detergents, fertilizers, and certain food items.',
    image: mainSackLaminatedImage,
    features: ['Moisture and Water Resistant', 'Enhanced Print Quality', 'Increased Strength and Durability', 'Suitable for Fine Materials', 'Protects from External Contamination'],
    gallery: [
        { name: 'Laminated Sack - Type 1', src: sack_laminated1, alt: 'Laminated Sack' },
        { name: 'Laminated Sack - Type 2', src: sack_laminated2, alt: 'Laminated Sack variation' },
    ]
  },
  {
    id: 'bags-bopp',
    name: 'BOPP Woven Bags',
    description: 'Biaxially Oriented Polypropylene (BOPP) film laminated bags offer superior print quality for retail packaging, providing excellent visual appeal along with strength.',
    image: mainSackBoppImage,
    features: ['High-Resolution Graphics Printing', 'Excellent Shelf Appeal', 'Water Resistant and Durable', 'Ideal for Pet Food, Rice, Specialty Grains', 'Anti-Skid Options Available'],
    gallery: [
        { name: 'BOPP Woven Sack', src: sack_bopp, alt: 'BOPP Woven Sack with high-quality print' },
        { name: 'PP BOPP Back Seal Sack', src: sack_block_bottom_seal_back, alt: 'PP BOPP Back Seal Sack' },
    ]
  },
  {
    id: 'bags-block-bottom',
    name: 'Block Bottom Bags',
    description: 'Block bottom (or brick-shape) bags offer excellent palletization and stability due to their flat base. Ideal for automated filling lines and retail display.',
    image: mainSackBlockBottomImage,
    features: ['Superior Stability and Stacking', 'Optimal Pallet Utilization', 'Suitable for Automated Filling', 'Valve or Open Mouth Options', 'Ideal for Cement, Chemicals, Resins'],
    gallery: [
        { name: 'Block Bottom Sack', src: sack_block_bottom, alt: 'Block Bottom Sack for stability' },
        { name: 'Block Bottom Back Seal Sack', src: sack_block_bottom_seal_back, alt: 'Block Bottom Back Seal Sack' },
    ]
  },
  {
    id: 'special-products',
    name: 'Special Products & Custom Solutions',
    description: 'Beyond our standard offerings, we provide custom-engineered packaging solutions, including specialized PE films, thermal pallet covers, and container safety sheets. Explore our specialized solutions below.',
    image: mainSpecialProductsImage,
    isParentCategory: true,
    subCategories: [
        'special-products-pe-film',
        'special-products-thermal-pallet-cover',
        'special-products-container-safety-sheets'
    ],
    features: [
        'Tailor-Made Designs for Unique Needs',
        'Advanced Material Combinations',
        'Solutions for Barrier Protection & Strength',
        'Consultation and Prototyping Services',
        'Innovative Problem-Solving for Packaging Challenges'
    ],
    gallery: [
        { name: 'Overview of Special Products', src: mainSpecialProductsImage, alt: 'Overview of Special Products' },
        { name: 'PE Film Example', src: mainPefilmImage, alt: 'PE Film Example' },
        { name: 'Thermal Pallet Cover Example', src: mainThermalPalletCoverImage, alt: 'Thermal Pallet Cover Example' },
    ]
  },
  {
    id: 'special-products-pe-film',
    name: 'Specialized PE Films',
    description: 'We offer a range of Polyethylene (PE) films, including options for barrier protection, lamination, and specialized industrial applications. Available in various thicknesses and properties.',
    image: mainPefilmImage,
    features: [
        'Excellent Barrier Properties (Moisture, Oxygen)',
        'Food-Grade Materials Available',
        'Options for Lamination and Coating',
        'Mono and Co-extruded Films',
        'Customizable Thickness and Width'
    ],
    gallery: [
      { name: 'PE Film Roll Example', src: mainPefilmImage, alt: 'PE Film Roll' },
      { name: 'Detailed PE Film Machine', src: pe_pefilm0, alt: 'Detailed PE Film Example 0' },
      { name: 'Detailed PE Film Machine', src: pe_pefilm1, alt: 'Detailed PE Film Example 1' },
      { name: 'Detailed PE Film Preperation', src: pe_pefilm2, alt: 'Detailed PE Film Example 2' },
      { name: 'Detailed PE Film Extruder', src: pe_pefilm3, alt: 'Detailed PE Film Example 3' },
      { name: 'Detailed PE Film Extruder', src: pe_pefilm4, alt: 'Detailed PE Film Example 4' },
      { name: 'Detailed PE Film Valve', src: pe_pefilm5, alt: 'Detailed PE Film Example 5' },
      { name: 'Detailed PE Film Material', src: pe_pefilm6, alt: 'Detailed PE Film Example 6' },
      { name: 'Coextruded Film Example 0', src: pe_w1400coex0, alt: 'Coextruded Film 0' },
      { name: 'Coextruded Film Example 1', src: pe_w1400coex1, alt: 'Coextruded Film 1' },
      { name: 'Coextruded Film Example 2', src: pe_w1400coex2, alt: 'Coextruded Film 2' },
      { name: 'Coextruded Film Example 3', src: pe_w1400coex3, alt: 'Coextruded Film 3' },
      { name: 'Coextruded Film Example 4', src: pe_w1400coex4, alt: 'Coextruded Film 4' },
      { name: 'Coextruded Film Example 5', src: pe_w1400coex5, alt: 'Coextruded Film 5' },
      { name: 'Coextruded Film Example 6', src: pe_w1400coex6, alt: 'Coextruded Film 6' },
      { name: 'Coextruded Film Example 7', src: pe_w1400coex7, alt: 'Coextruded Film 7' },
      { name: 'Coextruded Film Example 8', src: pe_w1400coex8, alt: 'Coextruded Film 8' },
    ]
  },
  {
    id: 'special-products-thermal-pallet-cover',
    name: 'Thermal Pallet Cover',
    description: 'ABP Big Bag thermal pallet cover is a special type of cover that does not pass water and wind as well as cold and heat. It consists of two different surfaces: One side manages to keep it cool thanks to its sun protection, while the other side keeps the contents warm by trapping the heat, thus preventing damage. Please contact us for the supply of thermal pallet covers in special sizes for your needs.',
    image: mainThermalPalletCoverImage,
    features: [
        'Water and wind resistant',
        'Dual-surface for cooling and heating',
        'Prevents temperature damage',
        'Custom sizes available upon request',
        'Ideal for pallet protection during transport'
    ],
    gallery: [
        { name: 'Thermal Pallet Cover Example 1', src: thermal_blanket1, alt: 'Thermal Pallet Cover Example 1' },
        { name: 'Thermal Pallet Cover Example 2', src: thermal_blanket2, alt: 'Thermal Pallet Cover Example 2' },
        { name: 'Thermal Pallet Cover Example 3', src: thermal_blanket3, alt: 'Thermal Pallet Cover Example 3' },
    ]
  },
  {
    id: 'special-products-container-safety-sheets',
    name: 'Container Safety Sheets',
    description: 'Our Container Safety Sheets provide essential protection and security for goods during container transport. Available in standard, inflatable, and safety net designs to suit various cargo types and requirements.',
    image: mainContainerSafetySheetImage,
    features: [
        'Enhances cargo safety during transit',
        'Prevents shifting and damage to goods',
        'Available in Standard, Inflatable, and Safety Net types',
        'Durable materials for reliable performance',
        'Easy to install and remove',
        'Custom solutions available for specific needs'
    ],
    gallery: [
        { name: 'Standard Safety Sheet 1', src: css_standart1, alt: 'Standard Container Safety Sheet 1' },
        { name: 'Standard Safety Sheet 2', src: css_standart2, alt: 'Standard Container Safety Sheet 2' },
        { name: 'Standard Safety Sheet 3', src: css_standart3, alt: 'Standard Container Safety Sheet 3' },
        { name: 'Inflatable Safety Sheet 1', src: css_inflatable1, alt: 'Inflatable Container Safety Sheet 1' },
        { name: 'Inflatable Safety Sheet 2', src: css_inflatable2, alt: 'Inflatable Container Safety Sheet 2' },
        { name: 'Inflatable Safety Sheet 3', src: css_inflatable3, alt: 'Inflatable Container Safety Sheet 3' },
        { name: 'Safety Net 1', src: css_safetynet1, alt: 'Container Safety Net 1' },
        { name: 'Safety Net 2', src: css_safetynet2, alt: 'Container Safety Net 2' },
        { name: 'Safety Net Accessory 1', src: css_safetynet_accessory1, alt: 'Container Safety Net Accessory 1' },
        { name: 'Safety Net Accessory 2', src: css_safetynet_accessory2, alt: 'Container Safety Net Accessory 2' },
    ]
  }
];

const ProductDetailPage = () => {
  const { productId } = useParams();
  const product = productData.find(p => p.id === productId);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [productId]);

  useEffect(() => {
    if (product) {
      if (product.isParentCategory) {
        const imageToShow = product.gallery && product.gallery.length > 0 ? product.gallery[0] : { src: product.image, alt: product.name, name: "Category Overview" };
        setSelectedImage(imageToShow);
      } else if (product.gallery && product.gallery.length > 0) {
        setSelectedImage(product.gallery[0]);
      } else if (product.image) {
        setSelectedImage({ src: product.image, alt: product.name, name: "Main Image" });
      } else {
        setSelectedImage(null);
      }
    } else {
        setSelectedImage(null);
    }
  }, [product]);

  let parentCategoryForBreadcrumb = null;
  if (product && !product.isParentCategory) {
    parentCategoryForBreadcrumb = productData.find(p => p.isParentCategory && p.subCategories && p.subCategories.includes(productId));
  }

  if (!product) {
    return (
      <main id="main" className="product-detail-page-new">
        <section id="breadcrumbs" className="breadcrumbs">
          <div className="container">
            <ol>
              <li><Link to="/"><i className="fas fa-home"></i></Link></li>
              <li><Link to="/products">Products</Link></li>
              <li>Product Not Found</li>
            </ol>
          </div>
        </section>
        <div className="container" style={{ textAlign: 'center', padding: '60px 20px' }}>
          <h2>Product Not Found</h2>
          <p style={{ marginBottom: '30px' }}>The product you are looking for does not exist or may have been moved.</p>
          <Link to="/products" className="btn-primary-style" style={{ textDecoration: 'none' }}>
            Back to All Products
          </Link>
        </div>
      </main>
    );
  }

  if (product.isParentCategory && product.subCategories) {
    const subCategoryDetails = product.subCategories
      .map(subId => productData.find(p => p.id === subId))
      .filter(p => p);

    return (
        <main id="main" className="product-detail-page-new">
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <ol>
                        <li><Link to="/"><i className="fas fa-home"></i></Link></li>
                        <li><Link to="/products">Products</Link></li>
                        <li>{product.name}</li>
                    </ol>
                </div>
            </section>
            <div className="container page-container-custom">
                <div className="product-header">
                    <h1>{product.name}</h1>
                    <div className="title-bar-custom"></div>
                    {product.description && <p className="category-description">{product.description}</p>}
                </div>

                {subCategoryDetails.length > 0 && (
                    <div className="subcategory-section">
                        <h2 className="subcategory-section-title">Explore Our {product.name} Types</h2>
                        <div className="subcategory-grid">
                            {subCategoryDetails.map(subCat => (
                                <Link key={subCat.id} to={`/products/${subCat.id}`} className="subcategory-card">
                                    <img src={subCat.image} alt={subCat.name} />
                                    <div className="subcategory-card-content">
                                        <h3>{subCat.name}</h3>
                                        <span className="btn-view-subcategory">View Details</span>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </main>
    );
  }

  const handleThumbnailClick = (image) => {
    setSelectedImage(image);
  };

  return (
    <main id="main" className="product-detail-page-new">
      <section id="breadcrumbs" className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/"><i className="fas fa-home"></i></Link></li>
            <li><Link to="/products">Products</Link></li>
            {parentCategoryForBreadcrumb && (
                <li><Link to={`/products/${parentCategoryForBreadcrumb.id}`}>{parentCategoryForBreadcrumb.name}</Link></li>
            )}
            <li>{product.name}</li>
          </ol>
        </div>
      </section>

      <div className="container page-container-custom">
        <div className="product-header">
          <h1>{product.name}</h1>
          <div className="title-bar-custom"></div>
        </div>

        <div className="product-layout-grid">
          <div className="product-gallery-section">
            {selectedImage ? (
              <div className="main-image-view">
                <img src={selectedImage.src} alt={selectedImage.alt || `Main view of ${product.name}`} />
                {selectedImage.name && <p className="selected-image-caption">{selectedImage.name}</p>}
              </div>
            ) : (
              product.image ?
              <div className="main-image-view">
                <img src={product.image} alt={`Main view of ${product.name}`} />
              </div>
              :
              <div className="main-image-view placeholder">
                <p>Image Coming Soon</p>
              </div>
            )}
            {product.gallery && product.gallery.length > 1 && (
              <div className="thumbnail-strip">
                {product.gallery.map((img, index) => (
                  <div
                    key={index}
                    className={`thumbnail-item ${selectedImage && selectedImage.src === img.src ? 'active' : ''}`}
                    onClick={() => handleThumbnailClick(img)}
                    title={img.name || `View ${product.name} - Image ${index + 1}`}
                  >
                    <img src={img.src} alt={img.alt || `Thumbnail ${index + 1} for ${product.name}`} />
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className="product-info-section">
            <p className="product-description-detail">{product.description}</p>

            {product.features && product.features.length > 0 && (
              <div className="product-features-detail">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            )}
            
            {product.gallery && product.gallery.length > 0 && product.gallery.some(v => v.name && v.name !== product.name) && (
                <div className="product-variations-list">
                    <h3>Available Types / Examples</h3>
                    <p>This product comes in various types or configurations as shown in the gallery. Click thumbnails to see different examples.</p>
                </div>
            )}

            <Link to="/products/request" className="btn-primary-style request-quote-btn" style={{ textDecoration: 'none' }}>
              Request a Quote
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ProductDetailPage;